import { Map, List, fromJS } from 'immutable';

export function request(state, { userId, bets, selectedLegs }) {
    state = state.setIn([ 'possibleBets', userId ], Map({
        state: 'IN_PROGRESS'
    }));

    return state;
}

export function error(state, { userId, errors }) {
    console.error('Haven\'t found a way to make another error - shouldn\'t happen', userId, errors);
    state = state.setIn([ 'possibleBets', userId ], Map({
        state: 'ERROR',
        errors: fromJS(errors)
    }));

    return state;
}

export function finish(state, { userId, bets, combinations, errors, success, bonusEngineFreeBets }) {
    state = state.setIn([ 'possibleBets', userId ], Map({
        state: 'FINISHED',
        errors: success ? null : fromJS(errors)
    }));

    state = state.setIn([ 'bonusEngineFreeBets', userId ], fromJS(bonusEngineFreeBets));

    delete combinations['SGL'];

    state = state.setIn([ 'combinations', userId ], fromJS(combinations).toList());

    let mappedBets = {};

    bets.forEach(bet => {
        if (bet.uid.indexOf('temp-') === -1) {
            mappedBets[bet.uid] = bet;
        }
    });

    let multiples = bets.filter(bet => bet.uid.indexOf('temp-') !== -1);

    let userMultiples = state.getIn([ 'multiples', userId ], Map());
    userMultiples = userMultiples.map(um => {
        let multiple = multiples.find(m => m.uid === um.get('uid'));

        if (!multiple) {
            return um;
        }

        return um
            .set('errors', fromJS(multiple.errors))
            .set('potentialReturns', multiple.potentialReturns)
            .set('freebetCredits', fromJS(multiple.freebetCredits))
            .set('freebetRemarks', fromJS(multiple.freebetRemarks))
            .set('freeBets', fromJS(multiple.freeBets));
    });

    let userBets = state.getIn([ 'bets', userId ]) || List();
    userBets = userBets.map(bet => {
        let betResult = mappedBets[bet.get('uid')];

        if (!betResult) {
            return bet;
        }

        if (combinations[bet.get('type')]) {
            bet = bet
                .set('name', combinations[bet.get('type')].name)
                .set('numLines', combinations[bet.get('type')].numLines);
        }

        // Price can be under 0 and then this bet is incorrect (happens for each way on events without EW)
        return bet
            .set('errors', fromJS(betResult.errors))
            .set('potentialReturns', betResult.potentialReturns)
            .set('potentialReturnsAt', betResult.stakePerLine)
            .set('freebetCredits', fromJS(betResult.freebetCredits))
            .set('freebetRemarks', fromJS(betResult.freebetRemarks))
            .set('freeBets', fromJS(betResult.freeBets))
            .set('price', betResult.price && betResult.price.f.charAt(0) !== '-' ? betResult.price.f : null)
            .set('maxStake', betResult.maxStake);
    });

    return state
        .setIn([ 'multiples', userId ], userMultiples)
        .setIn([ 'bets', userId ], userBets);
}
